import { logError } from '../../logging';

export const getCookie = (cookieName: string) => {
  try {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${cookieName}=`))
      ?.split('=')[1];
  } catch (error) {
    logError(`Could not get cookie ${cookieName}`, error);
  }
};
